/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import DropDown from 'app/components/common/DropDown.jsx';
import Loading from 'app/components/common/Loading.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import GenericItem from 'app/components/DropDownItems/GenericItem.jsx';
import CurateListItemComponent from 'app/components/Curate/CurateListItemComponent.jsx';
import * as _ from 'underscore';
import ListActionButton from 'app/components/common/ListActionButton.jsx';
import { FormattedDate } from 'react-intl';
import { FormattedTime } from 'react-intl';
import Utilities from 'app/utility/Utilities.js';

/**
 * Whether the account has never curated: CURATION_ID answered without a route, which only a first
 * feed makes, so there are no items to fetch. Asked of hasNoData, which only an empty answer sets,
 * rather than of CURATION_ID's loading flag, which can settle a render before the route arrives.
 */
function hasNoCuratedRoute(props) {

    return props.app.hasNoData.CURATION_ID === true && props.curation.route.id === undefined;

}

class CurateListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            curatedRouteId: 0,
            inputs: [],
            hoverItem: false,
            itemFilterKey: 0,
            itemSortKey: 'newestFirst',
            showFilterDropDown: false,
            showOrientation: true,
            shareItemId: 0,
            showSortDropDown: false,
            sortCriteria: [
                {
                    id: 'newestFirst',
                    name: 'Newest first',
                    key: 'enqueueTs',
                    order: 'desc'
                }, {
                    id: 'oldestFirst',
                    name: 'Oldest first',
                    key: 'enqueueTs',
                    order: 'asc'
                }
            ]
        };

        this.dropDownResetHandler = this.dropDownResetHandler.bind(this);
        this.addCuratedFeed = this.addCuratedFeed.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.itemFilterClick = this.itemFilterClick.bind(this);
        this.itemSortClick = this.itemSortClick.bind(this);
        this.toggleFilterDropdown = this.toggleFilterDropdown.bind(this);
        this.toggleSortDropdown = this.toggleSortDropdown.bind(this);
        this.showShareModal = this.showShareModal.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        if (props.curation.route.inputs !== undefined && state.inputs.length === 0) {
            let inputs = Utilities.deepClone(props.curation.route.inputs);
            inputs = _.uniq(inputs, function(item) {
                return item.id;
            });
            inputs.push({
                id: null,
                name: 'All items',
                type: 100
            });
            nextState.inputs = inputs;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        if (this.props.curation.route.id) {
            this.props.getCurations(this.props.curation.route.id);
        } else if (hasNoCuratedRoute(this.props)) {
            this.props.router.navigate('/share/curate/feeds/new');
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.curation.route.id === undefined && this.props.curation.route.id !== undefined) {
            this.props.getCurations(this.props.curation.route.id);
        }

        if (!hasNoCuratedRoute(prevProps) && hasNoCuratedRoute(this.props)) {
            this.props.router.navigate('/share/curate/feeds/new');
        }

        if (prevProps.app.loading.CURATION_LIST === true && this.props.app.loading.CURATION_LIST === false) {
            if ((this.props.curation.route.inputs === undefined ||
                this.props.curation.route.inputs.length === 0) &&
                !this.props.router.location.pathname.match("new")) {
                this.props.router.navigate('/share/curate/feeds/new');
            }
            this.setState({
                loading: false
            });
        }

    }


    dropDownResetHandler(which) {
        let state = this.state;

        if (which === 'filter') {
            this.setState({
                showFilterDropDown: false
            });
        } else if (which === 'sort') {
            this.setState({
                showSortDropDown: false
            });
        }

    }

    addCuratedFeed(e) {
        e.preventDefault();

        this.props.router.navigate('/share/curate/feeds/new');

    }

    removeItem(e) {
        let itemId = e.currentTarget.dataset.itemid;

        this.props.deleteCuration({
            id: this.props.curation.route.id,
            idlist: [itemId]
        });

    }

    itemFilterClick(item, e) {

        this.setState({
            itemFilterKey: item.id,
            showFilterDropDown: false
        });

    }

    itemSortClick(item, e) {

        this.setState({
            itemSortKey: item.id,
            showSortDropDown: false
        });

    }

    toggleFilterDropdown(e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            showFilterDropDown: !this.state.showFilterDropDown
        });

    }

    toggleSortDropdown(e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            showSortDropDown: !this.state.showSortDropDown
        });

    }

    showShareModal(e) {
        let itemId = parseInt(e.currentTarget.dataset.itemid, 10),
            item = _.find(this.props.curation.items, {id: itemId});

        if (item) {
            this.props.persistData('curationItem', item);
            this.props.router.navigate('/content/post');
        }

    }


    render() {

        let constants = this.props.app.config.constants,
            userHasUsedCuration = constants.PUB_OPTIONS_HAS_CURATED & this.props.user.detail.options,
            controls = '',
            inputType = 100,
            itemList = this.props.curation.items,
            filterList = '',
            filterButtonLabel = 'All items',
            referenceDate = null,
            sortList = '',
            sortCriterion = '',
            sortButtonLabel = 'Newest first',
            shareMethod = this.showShareModal,
            removeMethod = this.removeItem,
            emptyStateMessage = (
                <div>
                    <span>There are no fresh items from your curated feed(s). {"We'll check for new items shortly."}</span>
                    <ListActionButton buttonLabel={"Add New Feed"} action={this.addCuratedFeed}/>
                </div>
            );

        if (this.props.app.configLoaded === false || this.props.app.userLoaded === false || this.props.app.loading.curation) {
            return (
                <Loading />
            );
        }

        if (this.state.itemFilterKey) {
            itemList = _.filter(itemList, (item) => {
                return item.iID == this.state.itemFilterKey;
            });

            let inputs = this.props.curation.route.inputs.filter((input) => {
                return input.id === this.state.itemFilterKey;
            });
            if (inputs.length) {
                filterButtonLabel = inputs[0].name;
            }
        }

        if (this.state.showFilterDropDown) {
            filterList = (
                <DropDown
                    id="filter"
                    items={this.state.inputs}
                    itemElement={FilterItem}
                    clickHandler={this.itemFilterClick}
                    dropDownClass="filter-dd"
                    resetHandler={this.dropDownResetHandler}/>
            );
        }

        /**
         * Sort the input list
         */
        if (this.state.itemSortKey) {

            /**
             * Get the sort criterion.
             * Sort criteria are in state (this.state.sortCriteria), and
             * defined in this.getInitialState, or updated by an
             * act of React.
             */
            sortCriterion = this.state.sortCriteria.filter((item) => {
                return item.id === this.state.itemSortKey;
            })[0];

            /**
             * The name of the sort criterion displays on the sort
             * dropdown control
             */
            sortButtonLabel = sortCriterion.name;

            /**
             * Sort the list of items using Array.prototype.sort by
             * switching on sort order, and using the appropriate
             * comparator
             */
            switch (sortCriterion.order) {
                case 'asc':
                    itemList.sort(function(a, b) {
                        let ret = 0;
                        if (a[sortCriterion.key] > b[sortCriterion.key]) {
                            ret = 1;
                        } else if (a[sortCriterion.key] < b[sortCriterion.key]) {
                            ret = -1;
                        }
                        return ret;
                    });
                    break;
                case 'desc':
                    itemList.sort(function(a, b) {
                        let ret = 0;
                        if (a[sortCriterion.key] < b[sortCriterion.key]) {
                            ret = 1;
                        } else if (a[sortCriterion.key] > b[sortCriterion.key]) {
                            ret = -1;
                        }
                        return ret;
                    });
                    break;
            }
        }

        if (this.state.showSortDropDown) {
            sortList = (
                <DropDown
                    id="sort"
                    items={this.state.sortCriteria}
                    itemElement={GenericItem}
                    clickHandler={this.itemSortClick}
                    dropDownClass="sort-dd"
                    resetHandler={this.dropDownResetHandler}/>
            );
        }

        let itemRenderer = (item) => {

            let itemDate,
                formattedDate,
                ret;

            /**
             * Instantiate a date from the item's timestamp
             *
             * @type {Date}
             */
            itemDate = new Date(item.enqueueTs);

            ret = [];

            /**
             * The referenceDate is a variable in the parent scope. It's
             * used to group items on a given date, so if there is no reference
             * date, or the reference date is not the same as the item date
             * make a header, and push to ret
             */
            if (!referenceDate || referenceDate.toDateString() !== itemDate.toDateString()) {
                referenceDate = new Date(item.enqueueTs);
                formattedDate = '';
                if (itemDate instanceof Date) {
                    formattedDate = <FormattedDate value={itemDate} day="numeric" month="long" year="numeric"/>;
                }
                ret.push(
                    <div key={referenceDate} className="item-group-header curate-item-group-header">
                        {formattedDate}
                    </div>
                );
            }

            ret.push(
                <CurateListItemComponent
                    {...this.props}
                    item={item}
                    key={'curateitem-' + item.id}
                    inputs={this.props.curation.route.inputs}
                    shareMethod={shareMethod}
                    removeMethod={removeMethod}/>
            );

            return ret;

        }

        let noItems = () => {

            return <EmptyState message={emptyStateMessage}/>;

        }

        /**
         * Check both the curated flag (true if a user has curated something) and
         * state (in case the user has not curated anything, but has closed the orientation
         * panel during this session)
         */
        if (!userHasUsedCuration && this.state.showOrientation) {
            controls = (
                <FeedEditorTabs
                    {...this.props}
                    inputType={inputType}
                    feedLabel='none'
                    showSocial={false}
                    showOrientation={!userHasUsedCuration}
                    currentSection='config'
                    feedType='curated'
                    routeViewType='config'/>
            );
        }

        return (
            <div className="dlvr-item-list">
                {controls}
                <div className="item-list-controls curate-item-list-controls">
                    <div className="item-list-control curate-item-list-control item-list-filter curate-item-list-filter control">
                        <span onClick={this.toggleFilterDropdown} role="button" aria-label={filterButtonLabel}>
                            {filterButtonLabel}
                            <i className="fa fa-chevron-down"/>
                        </span>
                    </div>
                    <div className="item-list-control curate-item-list-control item-list-sort curate-item-list-sort">
                        <span onClick={this.toggleSortDropdown} role="button" aria-label={sortButtonLabel}>
                            {sortButtonLabel}
                            <i className="fa fa-chevron-down"/>
                        </span>
                    </div>
                    {filterList}
                    {sortList}
                </div>
                {itemList.length
                    ? itemList.map(itemRenderer)
                    : noItems()}
            </div>
        );
    }
};

CurateListComponent.displayName = "CurateListComponent";

CurateListComponent.propTypes = {
    items: PropTypes.array,
    currentModal: PropTypes.object
};

// flashMessages: {
//     emptyState: 'You don\'t have any items to Curate. Add sites to populate your pool of content'
// },

CurateListComponent.defaultProps = {
    items: [],
    currentModal: null
};

export default CurateListComponent;
